export const normalizeCloudSearchItem = (result) => {
  const { id, fields } = result;
  
  const type = result.fields.asset_type[0];

  // Movie / Series / Cast
  if (type !== 'Network') {
    const {
      asset_type,
      title,
      path,
      image_url,
      formatted_title,
      cast_names,
      cast_person_ids,
    } = fields;

    const topCast = cast_names
      ? cast_names.map((name, i) => ({
          name,
          personId: cast_person_ids ? cast_person_ids[i] : null,
        }))
      : null;

    return {
      id,
      path: path[0],
      assetType: asset_type[0],
      title: title[0],
      formattedTitle: formatted_title[0],
      imageUrl: image_url[0],
      topCast,
      offer: null,
    };
  }

  // Network
  if (type === 'Network') {
    const { display_name, image_url, path } = fields;

    return {
      displayName: display_name[0],
      networkImgUrl: image_url[0],
      path: path[0],
    };
  }
};
